import React, { useContext, useState, useEffect } from 'react';
import ModalContext from '../../../context/ModalContext.js';
import AuthContext from '../../../context/AuthContext.js';
import { CloseRounded } from '@mui/icons-material';
import { Button, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';

const DeleteCouponModal = ({ modalDetails }) => {
  const modalCtx = useContext(ModalContext);
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const coupon = modalDetails?.coupon;
  const isDraft = coupon?.status === 'draft';

  const closeHandle = () => {
    modalCtx.closeModal();
  }

  const handleDeleteOrExpire = async () => {
    setLoading(true);
    try {
      if (isDraft) {
        // Delete draft coupon
        await deleteDraftCoupon();
      } else {
        // Expire published coupon
        await expirePublishedCoupon();
      }
    } catch (error) {
      console.error('Error processing coupon:', error);
      setLoading(false);
    }
  }

  const deleteDraftCoupon = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/coupon/${coupon.id}`, {
        method: 'DELETE',
        headers: { 
          'Content-Type': 'application/json', 
          Authorization: "Bearer " + authCtx.token 
        }
      });
      
      const data = await response.json();
      
      if (data.status === 'success') {
        modalCtx.closeModal();
        modalCtx.setPageUpdate({ 
          page: "Coupons", 
          couponId: coupon.id 
        });
      }
    } catch (error) {
      console.error('Error deleting coupon:', error);
    }
  }

  const expirePublishedCoupon = async () => {
    try {
      // Set expiry date to yesterday
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const formattedDate = yesterday.toISOString().split('T')[0]; // "YYYY-MM-DD"

      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/coupon/${coupon.id}`, {
        method: 'PATCH',
        headers: { 
          'Content-Type': 'application/json', 
          Authorization: "Bearer " + authCtx.token 
        },
        body: JSON.stringify({
          validTill: formattedDate,
          validFor: 0,
          status: 'expired'
        })
      });
      
      const data = await response.json();
      
      if (data.status === 'success') {
        modalCtx.closeModal();
        modalCtx.setPageUpdate({ 
          page: "Coupons", 
          couponId: coupon.id 
        });
      }
    } catch (error) {
      console.error('Error expiring coupon:', error);
    }
  }

  return (
    <>
      <div className="create-devotional-container">
        <div className='devotional-header'>
          <h1>{isDraft ? 'Delete Coupon' : 'Expire Coupon'}</h1>
          <CloseRounded className='close' onClick={() => closeHandle()} />
        </div>
        <div className="body-container create-container">
          {isDraft ? (
            <>
              <span className="modal-message">
                Are you sure you want to delete this draft coupon?
              </span>
              <span className="modal-subtitle">
                This action will permanently delete the coupon and all associated records. This action cannot be undone.
              </span>
            </>
          ) : (
            <>
              <span className="modal-message">
                This coupon cannot be deleted because it has been published.
              </span>
              <span className="modal-subtitle">
                However, you can expire this coupon by setting its expiry date to yesterday. This will make the coupon inactive.
              </span>
            </>
          )}
        </div>
        <div className="footer-devotional">
          <Button 
            style={{color:"#555"}} 
            onClick={() => closeHandle()}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            style={{
              color: isDraft ? "#d32f2f" : "#f57c00",
              fontWeight: "bold"
            }}
            onClick={handleDeleteOrExpire}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : isDraft ? (
              'Delete'
            ) : (
              'Expire'
            )}
          </Button>
        </div>
      </div>
    </>
  )
}

export default DeleteCouponModal;
